import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'whatwg-fetch';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import queryParser from './utils/queryParser';
import { applyFaviconBasedOnBrandId, removeHashUrl, saveHrefOnBrowserLoad } from './utils';
import { CSS_LOADING_DELAY, BRAND_ID, VM_BRAND, CB_BRAND } from './utils/constants';
import configureStore from './store';
import { fetchConfig, updateCSSLoading } from './infrastructure/config';
import { fetchContent } from './infrastructure/content';
import { deleteToken } from './infrastructure/token';
import App from './routes';
import sessionUtils from './utils/sessionUtil';
import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';

const primaryBrand = () => import('web-ui-components/lib/app.vm.css');
const secondaryBrand = (brandId) =>
  brandId === CB_BRAND
    ? import('web-ui-components/lib/app.cb.css')
    : import('web-ui-components/lib/app.yb.css');

const parsedParams = queryParser()
  .update('bank_id', 'cb', (val) => val.toUpperCase())
  .update('brand_id', 'cb', (val) => val.toUpperCase());

saveHrefOnBrowserLoad(window.location.href);
removeHashUrl(
  `${BRAND_ID}=${parsedParams.get(BRAND_ID) !== VM_BRAND ? parsedParams.get(BRAND_ID) : VM_BRAND}`
);
const store = configureStore({
  config: parsedParams
});

const brandId = store.getState().config.get(BRAND_ID);
brandId === VM_BRAND ? primaryBrand() : secondaryBrand(brandId);

const onExpiry = () => {
  sessionUtils.clearTimeOut();
  const token = store.getState().config.get('access_token');
  const bankId = store.getState().config.get('bank_id');

  store.dispatch(deleteToken(token, bankId));
};
applyFaviconBasedOnBrandId(brandId);

Promise.all([store.dispatch(fetchConfig()), store.dispatch(fetchContent())]).then(() => {
  setTimeout(() => {
    store.dispatch(updateCSSLoading(true));
  }, CSS_LOADING_DELAY);

  sessionUtils.appSessionManagement(onExpiry);
  ReactDOM.render(
    <Provider store={store}>
      <WebUIThemeProvider brandID={brandId}>
        <App />
      </WebUIThemeProvider>
      ,
    </Provider>,
    document.getElementById('business-details-web-app')
  );
});
